import { HighlightOutlined, UnorderedListOutlined, NotificationOutlined, RiseOutlined, FileOutlined, BankOutlined, ApartmentOutlined, AuditOutlined, RocketOutlined, ProfileOutlined, ProductOutlined, ReadOutlined, SolutionOutlined, TeamOutlined,UserOutlined,PlayCircleOutlined, VideoCameraOutlined, FileDoneOutlined } from '@ant-design/icons';
export const publicRoutes = [
  {
    path: "/login",
    component: "./pages/Login/Login.react"
  },
  {
    path: "/logout",
    component: "./pages/Login/Login.react"
  },
  {
    path: "/user/confirm/:confirmationToken",
    component: "./pages/Signup/Signup.react"
  },
  {
    path: '/forgot-password',
    component: './pages/Login/ForgotPassword.react'
  },
  {
    path: "/change-password",
    component: "./pages/Login/ChangePassword.react"
  },
  {
    path: "/resource/:resourceType/:resourceId/token/:token/view",
    component: "./components/Share/ShareViewer"
  }
];

export const privateRoutes = [
  // MANAGEMENT ROUTES
  {
    name: 'GESTIONE',
    path: '/management',
    component: './pages/SystemsManager/SystemsManager',
    roles: ['ROLE_ADMIN', 'ROLE_ASSETMANAGER'],
    routes: [
      { name: <><BankOutlined /> Impianti</>, 
        path: '/management/systems', 
        component: './pages/SystemsManager/SystemsManager',
        disabled: false 
      },
      {
        name: <><ApartmentOutlined /> Circuiti</>,
        path: '/management/circuits',
        component: './pages/CircuitManager/CircuitManager',
        roles: ['ROLE_ADMIN', 'ROLE_ASSETMANAGER'],
      },
      {
        name: <><TeamOutlined /> Squadre</>,
        path: '/management/teamManagement',
        component: './pages/TeamManagement/TeamManagementManager',
        roles: ['ROLE_ADMIN', 'ROLE_ASSETMANAGER'],
      },
      {
        name: <><FileDoneOutlined /> Permessi</>,
        path: '/management/licenses',
        component: './pages/Licenses/LicensesManager',
        roles: ['ROLE_ADMIN', 'ROLE_ASSETMANAGER'],
      },
    ]
  },
  {
    path: '/',
    component: './pages/SystemsManager/SystemsManager',
    roles: ['ROLE_ADMIN']
  },

  // name: 'Systems'
  {
    path: '/management/systems/map',
    component: './pages/SystemsManager/SystemsManager',
    roles: ['ROLE_ADMIN', 'ROLE_ASSETMANAGER'],
  },
  {
    path: '/management/systems',
    component: './pages/SystemsManager/SystemsManager',
    roles: ['ROLE_ADMIN', 'ROLE_ASSETMANAGER'],
  },
  {
    path: '/management/systems/new',
    component: './pages/SystemsManager/SystemFormPage',
    roles: ['ROLE_ADMIN', 'ROLE_ASSETMANAGER'],
  },
  {
    path: '/management/systems/:id',
    component: './pages/SystemsManager/Systems.Detail',
    roles: ['ROLE_ADMIN', 'ROLE_ASSETMANAGER'],
  },

  // name: 'Circuits'
  {
    path: '/management/circuits',
    component: './pages/CircuitManager/CircuitManager',
    roles: ['ROLE_ADMIN', 'ROLE_ASSETMANAGER'],
  },

  // name: 'Providers'
  {
    path: '/management/teamManagement',
    component: './pages/TeamManagement/TeamManagementManager',
    roles: ['ROLE_ADMIN', 'ROLE_ASSETMANAGER'],
  },

  // name: 'Licenses'
  {
    path: '/management/licenses',
    component: './pages/Licenses/LicensesManager',
    roles: ['ROLE_ADMIN', 'ROLE_ASSETMANAGER'],
  },
  {
    path: '/management/licenses/:id',
    component: './pages/Licenses/LicenseDetail',
    roles: ['ROLE_ADMIN', 'ROLE_ASSETMANAGER'],
  },


  // SALES ROUTES
  {
    name: 'VENDITE',
    path: '/sales',
    component: './pages/Negotiations/NegotiationsManager',
    roles: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_SALESLEADER'],
    routes: [
      { name: <><UserOutlined /> Inserzionisti</>, path: '/sales/advertisers', disabled: false },
      { name: <><FileOutlined /> Trattative </>, path: '/sales/negotiations', disabled: false },
      { name: <>< ProfileOutlined /> Ordini</>, path: '/sales/orders', disabled: false },
      { name: <><RiseOutlined /> Dashboard Funnel</>, path: '/sales/dashboardAnalytics', disabled: false },
      //{ name: <><PlayCircleOutlined /> Palinsesto DOOH</>, path: '/playerDOOH', disabled: false }
      /*{ name: <><ProductOutlined /> Prodotti </>, path: '/estimates/products', key: 'products', disabled: false },
      { name: <><ReadOutlined /> Listini </>, path: '/estimates/products?catalogs', key: 'catalogs', disabled: false }, */
    ]
  },

  // name: 'Advertisers'
  {
    path: '/sales/advertisers',
    component: './pages/Advertisers/AdvertiserPage',
    roles: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_SALESLEADER']
  },
    {
    path: '/sales/advertisers/:id',
    component: './pages/Advertisers/AdvertiserDetailPage',
    roles: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_SALESLEADER']
  },

  // name: 'Negotiations'
  {
    path: '/sales/negotiations',
    component: './pages/Negotiations/NegotiationsManager',
    roles: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_SALESLEADER'],
  },
  {
    path: '/sales/negotiations/:id',
    component: './pages/Negotiations/NegotiationsDetail',
    roles: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_SALESLEADER'],
  },

  // name: 'Quotes'
  {
    path: "/sales/quote/:id/view",
    component: "./pages/Quotes/QuoteDetail.jsx",
    roles: ['ROLE_ADMIN', 'ROLE_PLANNER', 'ROLE_SUPERVISOR', 'ROLE_DESIGNER', 'ROLE_MEDIAMONITOR', 'ROLE_SALES', 'ROLE_SALESLEADER', 'ROLE_ASSETMANAGER']
  },
  {
    path: "/sales/quote/:id/edit",
    component: "./pages/Quotes/QuoteDetail.jsx",
    roles: ['ROLE_ADMIN', 'ROLE_PLANNER', 'ROLE_SUPERVISOR', 'ROLE_DESIGNER', 'ROLE_MEDIAMONITOR', 'ROLE_SALES', 'ROLE_SALESLEADER', 'ROLE_ASSETMANAGER']
  },

  // name: 'Orders'
  {
    path: "/sales/orders",
    component: "./pages/Orders/OrdersManager.jsx",
    roles: ['ROLE_ADMIN', 'ROLE_PLANNER', 'ROLE_SUPERVISOR', 'ROLE_DESIGNER', 'ROLE_MEDIAMONITOR', 'ROLE_SALES', 'ROLE_SALESLEADER', 'ROLE_ASSETMANAGER']
  },
  {
    path: "/sales/orders/:id",
    component: "./pages/Orders/OrderDetail.jsx",
    roles: ['ROLE_ADMIN', 'ROLE_PLANNER', 'ROLE_SUPERVISOR', 'ROLE_DESIGNER', 'ROLE_MEDIAMONITOR', 'ROLE_SALES', 'ROLE_SALESLEADER', 'ROLE_ASSETMANAGER']
  },
  
  {
    // name: 'Dashboard Analytics'
    path: '/sales/dashboardAnalytics',
    component: './pages/Analytics/DashboardAnalytics',
    roles: ['ROLE_ADMIN', 'ROLE_MEDIAMONITOR'],
  },


  // DELIVERY ROUTES
  {
    name: 'DISTRIBUZIONE',
    path: '/delivery',
    component: './pages/Plannings/PlanningsManager',
    roles: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_SALESLEADER'],
    routes: [
      { name: <><UnorderedListOutlined /> Pianificazioni</>, path: '/delivery/plannings', disabled: false },
      { name: <><NotificationOutlined /> Campagne </>, path: '/delivery/campaigns', disabled: false },
      { name: <><VideoCameraOutlined /> Espletamento</>, path: 'https://appeso-test.alessipubblicita.it', disabled: false },
      { name: <><RiseOutlined /> Programmatic DOOH</>, path: '/delivery/DOOHanalytics', disabled: false },
    ]
  },

  // name: 'Plannings'
  {
    path: '/delivery/plannings',
    component: './pages/Plannings/PlanningsManager',
    roles: ['ROLE_ADMIN']
  },
  {
    path: '/delivery/plannings/:id',
    component: './pages/Plannings/PlanningDetail',
    roles: ['ROLE_ADMIN']
  },
  {
    path: '/delivery/plannings/:id/search',
    component: './pages/Plannings/PlanningDetail',
    roles: ['ROLE_ADMIN']
  },

  // name: 'Campaigns'
  {
    path: '/delivery/campaigns',
    component: './pages/Campaigns/CampaignsManager',
    roles: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_SALESLEADER'],
  },
  {
    path: '/delivery/campaigns/:id',
    component: './pages/Campaigns/CampaignDetail',
    roles: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_SALESLEADER']
  },

  // name: 'Analitics DOOH'
  {
    path: '/delivery/DOOHanalytics',
    component: './pages/Analytics/DOOHAnalytics',
    roles: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_SALESLEADER'],
  },


  // MEDIA MONITOR ROUTES
  {
    name: 'MEDIA MONITOR',
    path: '/media-monitor',
    component: './pages/MediaMonitor/MediaMonitor',
    roles: ['ROLE_ADMIN', 'ROLE_MEDIAMONITOR'],
    routes: [
      { name: <><AuditOutlined /> Rilevazioni</>, path: '/media-monitor/monitor', disabled: false },
      { name: <><RiseOutlined /> Riepilogo</>, path: '/media-monitor/analytics', disabled: false },
      { name: <><HighlightOutlined /> Gestione Campi</>, path: '/media-monitor/manage', disabled: false },
    ]
  },

  {
    // name: 'Rilevazioni'
    path: '/media-monitor/monitor',
    component: './pages/MediaMonitor/MediaMonitor',
    roles: ['ROLE_ADMIN', 'ROLE_MEDIAMONITOR'],
  },
  {
    // name: 'Riepilogo'
    path: '/media-monitor/analytics',
    component: './pages/Analytics/MediaAnalytics',
    roles: ['ROLE_ADMIN', 'ROLE_MEDIAMONITOR'],
  },
  {
    // name: 'Gestione Campi'
    path: '/media-monitor/manage',
    component: './pages/MediaMonitor/MediaMonitorManageFields',
    roles: ['ROLE_ADMIN', 'ROLE_MEDIAMONITOR'],
  },


  // OTHER ROUTES
  {
    path: '/dooh-manage/manage',
    component: './pages/DoohManager/DoohManager',
    roles: ['ROLE_ADMIN'],
  },
  {
    // name: 'Shows',
    path: '/shows-manage/manage',
    component: './pages/ShowsManager/ShowsManager',
    roles: ['ROLE_ADMIN'],
  },
  {
    // name: 'Circuiti DOOH',
    path: '/dooh/players',
    component: './pages/Dooh/Players',
    roles: ['ROLE_ADMIN'],
  },
  {
    path: '/playerDOOH',
    component: './pages/Shows/ShowManager',
    roles: ['ROLE_ADMIN']
  },
/*   {
    path: '/estimates/products',
    component: './pages/Estimates/Products',
    roles: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_SALESLEADER'],
  }, */
  {
    path: '/settings/users',
    component: './pages/Settings/UsersSettings',
    roles: ['ROLE_ADMIN']
  },
  {
    path: "/profile",
    component: "./pages/Profile/Profile.jsx",
    roles: ['ROLE_ADMIN', 'ROLE_PLANNER', 'ROLE_SUPERVISOR', 'ROLE_DESIGNER', 'ROLE_MEDIAMONITOR', 'ROLE_SALES', 'ROLE_SALESLEADER', 'ROLE_ASSETMANAGER']
  },
  {
    path: "/test",
    component: "./pages/Test.jsx",
    roles: ['ROLE_ADMIN']
  },
];